<template>
    <div class="chartBox">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2 flexStart">
                <div style="color:#5cd9e8;margin-right: 10px;">
                    <i class="el-icon-s-data"></i>
                </div>
                <div class="flexStart">
                    <span class="fs-xl text mx-2" style="margin-right: 10px;">
                        报到率统计
                    </span>
                    <dv-decoration-1 style="width:30%;height:1rem;" />
                    <!-- <div style="color:rgb(92, 217, 232);margin-left:10px;">总招生率：{{ waterConfig.data[0] }}%</div> -->
                </div>
            </div>
            <div class="d-flex jc-center body-box feeContainer" style="height:calc(100% - 30px);margin-top: 10px;">
                <div class="flexBetween tagBox">
                    <el-tag effect="plain" size="mini" v-for="(item, idx) in DataList" :key="idx"
                        :class="item.title == title ? 'chckd' : ''" @click="showScore(item)">{{ item.title }}</el-tag>
                </div>

                <div class="flex_1" style="overflow-y:auto;margin-top:10px;">
                    <table class="dtable scoredt" style="">
                        <tr>
                            <th colspan="9">
                                {{ config.title }}【计划：{{ config.plan }}】【招生：{{ config.score ? config.score.zscount : 0
                                }}】
                            </th>
                        </tr>

                        <tr>
                            <td style="width:200px">专业</td>
                            <td>招生计划</td>
                            <td>实招人数</td>
                            <td>报到率</td>


                        </tr>
                        <tr v-for="(m, i) in config.majors" :key="i">
                            <td>
                                {{ m.title }}
                            </td>
                            <td>
                                {{ m.item_plan }}
                            </td>
                            <td>
                                {{ m.score ? m.score.zscount : '' }}
                            </td>
                            <td>
                                {{ m.score ? m.score.zsrate : '' }}
                            </td>

                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <!-- <xibuData :zsdata="config"></xibuData> -->
    </div>
</template>

<script>
import xibuData from "../../zs/majorscore.vue"
export default {
    props: ["waterConfig"],
    components: {
        xibuData
    },
    data() {
        return {
            DataList: [],
            config: [],
            title: '',
        };
    },


    mounted() { this.getList() },
    methods: {
        getList() {
            this.$http.post("/api/xuezhi_score_zstongji").then(res => {
                if (res.data) {
                    res.data.map(r => {
                        if (r.majors) {
                            r.majors.map(m => {
                                if (m.score) {
                                    m.score.zsrate = '0%'
                                    if (m.score && m.score.zscount && m.item_plan) {
                                        m.score.zsrate = ((m.score.zscount / m.item_plan) * 100).toFixed(2) + '%'
                                    } else {
                                        m.score.zsrate = '0%'
                                    } 
                                }
                               
                            })
                        }
                    })
                    this.DataList = res.data
                    this.config = res.data[0];
                    this.title = res.data[0].title


                }
              
            })
        },
        showScore(e) {
            // console.log(e)
            this.config = e;
            this.title = e.title

        }
    },
};
</script>
<style lang="less" type="text/less">
.feeContainer {
    .dv-capsule-chart {
        padding-bottom: 0;

        .capsule-container {
            flex: 0 0 60%;
        }
    }

    .unit-label {
        div {
            color: #0d1224;

        }
    }

    .unit-text {
        color: #0d1224;
        //color: pink;
    }
}

.tagBox {
    .el-tag {
        background-color: transparent !important;
        color: #5cd9e8;
        border-color: rgb(92, 217, 232);
        cursor: pointer;
    }

    .chckd {
        background-color: rgb(92, 217, 232) !important;
        color: #fff;
    }
}
</style>
<style scope lang="less" type="text/less">
.chartBox {
    width: 100%;
    height: 100%;
}

.scoredt tr td {
    border: 1px solid #ccc;
}

.scoredt td {
    border: 1px solid #ccc;
}

.scoredt th {
    border: 1px solid #ccc !important;
}
</style>
